import React, { useState } from 'react';

import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogContentText,
    Box,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import {Save} from "@mui/icons-material";

interface Props {
    visible: boolean;
    loading: boolean;
    title: string;
    description: string;
    color?: "error" | "inherit" | "primary" | "secondary" | "success" | "info" | "warning";
    onConfirm(): void;
    onHide(): void;
    onCancel(): void;
    storageKey?: string; // Optional key for localStorage
}

const SaveReportDialog: React.FC<Props> = ({
                                               visible,
                                               loading,
                                               title,
                                               color = 'error',
                                               description,
                                               onConfirm,
                                               onHide,
                                               onCancel,
                                               storageKey = 'dontShowSaveReportDialog',
                                           }) => {
    const [dontShowAgain, setDontShowAgain] = useState(false);

    const saveContext = () => {
        if (dontShowAgain && storageKey) {
            localStorage.setItem(storageKey, 'true');
        }
    }

    const handleConfirm = () => {
        saveContext();
        onConfirm();
    };

    const handleCancel = () => {
        saveContext();
        onCancel();
    };

    const handleClose = () => {
        setDontShowAgain(false);
        onHide();
    }

    return (
        <Dialog
            open={visible}
            onClose={handleCancel}
        >
            <DialogTitle fontWeight={500} textAlign={'left'}>
                {title}
            </DialogTitle>
            <DialogContent sx={{ mt: 1 }}>
                <DialogContentText textAlign={'left'} sx={{ mb: 2 }}>
                    {description}
                </DialogContentText>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={dontShowAgain}
                            onChange={(e) => setDontShowAgain(e.target.checked)}
                            disabled={loading}
                        />
                    }
                    label="Don't show this dialog again"
                />
            </DialogContent>
            <Box sx={{ borderTop: 1, m: 1, p: 1, gap : 2, display: "flex", borderColor: 'divider', background: 'background.default', flexDirection: "row-reverse" }}>
                <LoadingButton loading={loading} variant="alternate" onClick={handleConfirm} startIcon={<Save />}>
                    Save
                </LoadingButton>
                <LoadingButton loading={loading} variant="outlined-alternate" onClick={handleCancel}>
                    Don't Save
                </LoadingButton>
                <Button onClick={handleClose} disabled={loading} color='inherit'>
                    Close
                </Button>
            </Box>
        </Dialog>
    );
};

export default SaveReportDialog;